module.exports = __webpack_public_path__ + "static/media/FreedomEdge-20ml-logo.523e4360.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FreedomEdge-20ml-logo.png
// module id = 248
// module chunks = 0